import { useEffect } from "react";

import ResourceSections from "../../../molecules/Mobile/ResourceProviders/ResourceSections";

const FoodEntrepreneurs = () => {
  useEffect(() => {
    document.title = `HomeCook | Resource Providers`;
  }, []);

  return (
    <>
      <ResourceSections />
    </>
  );
};

export default FoodEntrepreneurs;
